export const isAdminImpersonating = () => {
  return document.cookie.includes('is-alitu-admin=');
};

export const setAdminImpersonating = () => {
  document.cookie = 'is-alitu-admin=true;path=/';
};

export const clearAdminImpersonating = () => {
  document.cookie = 'is-alitu-admin=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
};
